<template>
  <transition name="fade">
    <div
      v-if="isVisible"
      v-click-outside="close"
      class="edit-box"
      :class="isArrowVisible ? 'arrow' : ''"
      :style="'top: ' + yPos + 'px; left: ' + xPos + 'px;'"
    >
      <div class="edit-box__inner">
        <div>
          <slot name="input"></slot>
          <button
            v-if="$listeners.remove"
            class="btn btn-sm btn-outline-danger"
            @click="$emit('remove')"
          >
            Remove
          </button>
          <button
            v-if="$listeners.update"
            class="btn btn-sm btn-primary float-right"
            @click="close"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "modal-edit-box",

  props: {
    xPos: 0,
    yPos: 0,
    isVisible: false,
    isArrowVisible: true,
  },

  methods: {
    close() {
      this.$emit("update");
    },
  },
};
</script>
<style lang="scss" scoped>
.edit-box {
  background: #212120;
  border-radius: 8px;
  box-shadow: 0 0 8px rgba(#000, 0.7);
  color: #fff;
  opacity: 1;
  pointer-events: auto;
  position: absolute;
  transition: 200ms all ease-in-out;
  width: 250px;
  z-index: 100;
  transform: translateY(-100%);

  &__inner {
    max-height: 450px;
    overflow: scroll;
    padding: 20px;
  }

  &.arrow::before {
    content: "";
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%) rotate(180deg);
    width: 0;
    height: 0;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 15px solid #212120;
  }
}

.fade-enter-active {
  opacity: 1;
  // transform: rotate3d(0, 0, 0, 0deg);
}
.fade-leave-active {
  // transition: all 200ms cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  // transform: rotate3d(-.3, 1, 0, 20deg);
}
</style>
